export default "__VITE_ASSET__C0zbxw7R__"